export const SL_CAM_TIMEOUT = 'sl_cam_timeout';
export const SL_MULTI_CAM_ADS = 'sl_web_multicam_free_user';
export const SL_LOCALIZED_FEED = 'sl_localized_feed';
